import { Modal, Pressable, StyleSheet } from "react-native";

import { GText } from "@/components/g-text";
import { colors } from "@/constants/colors";

type RsvpChoice = "cancelled" | "confirmed" | "maybe";

interface RsvpModalProps {
  onClose: () => void;
  onSelect: (choice: RsvpChoice) => void;
  visible: boolean;
}

const options: { label: string; value: RsvpChoice }[] = [
  { label: "going", value: "confirmed" },
  { label: "maybe", value: "maybe" },
  { label: "can't make it", value: "cancelled" },
];

export default function RsvpModal({
  onClose,
  onSelect,
  visible,
}: RsvpModalProps) {
  return (
    <Modal
      animationType="fade"
      onRequestClose={onClose}
      transparent
      visible={visible}
    >
      <Pressable onPress={onClose} style={styles.backdrop}>
        <Pressable onPress={() => {}} style={styles.sheet}>
          <GText style={styles.title}>rsvp</GText>
          {options.map((opt) => (
            <Pressable
              key={opt.value}
              onPress={() => onSelect(opt.value)}
              style={({ pressed }) => [
                styles.option,
                pressed && styles.optionPressed,
              ]}
            >
              <GText style={styles.optionText}>{opt.label}</GText>
            </Pressable>
          ))}
        </Pressable>
      </Pressable>
    </Modal>
  );
}

const styles = StyleSheet.create({
  backdrop: {
    alignItems: "center",
    backgroundColor: colors.darkOverlay,
    flex: 1,
    justifyContent: "center",
  },
  option: {
    alignItems: "center",
    borderColor: colors.divider,
    borderRadius: 14,
    borderWidth: 1,
    marginBottom: 10,
    paddingVertical: 14,
  },
  optionPressed: {
    backgroundColor: colors.cardBg,
  },
  optionText: {
    color: colors.white,
    fontSize: 16,
    fontWeight: "600",
  },
  sheet: {
    backgroundColor: colors.sheet,
    borderColor: colors.cardBg,
    borderRadius: 20,
    borderWidth: 1,
    marginHorizontal: 24,
    maxWidth: 340,
    paddingHorizontal: 20,
    paddingVertical: 24,
    width: "100%",
  },
  title: {
    color: colors.light,
    fontSize: 14,
    fontWeight: "700",
    letterSpacing: 1,
    marginBottom: 16,
    textAlign: "center",
  },
});
